import { v1ApiClient } from '@/services';
import type {
  PathParams,
  RequestBody,
  ResponseBody,
} from '@/shared/api/generated';

type CredentialPath = '/v1/workspaces/{workspace_id}/yotpo/credential';

type CreateYotpoInfoParams = PathParams<CredentialPath, 'post'> &
  RequestBody<CredentialPath, 'post'>;

/**
 * Yotpo OAuth 인증 후 credential 생성
 */
export const createYotpoInfo = ({
  workspace_id,
  account_id,
  code,
  redirect_uri,
}: CreateYotpoInfoParams): Promise<ResponseBody<CredentialPath, 'post'>> =>
  v1ApiClient
    .post(`workspaces/${workspace_id}/yotpo/credential`, {
      account_id,
      code,
      redirect_uri,
    })
    .then((res) => res.data);
